import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
} from '@angular/core';
import {
    DataService,
    SharedModule,
    TypedBaseDetailComponent,
} from '@vendure/admin-ui/core';
import { UntypedFormGroup } from '@angular/forms';
import { ProductValidationDocument } from '../../generated/product-validation/graphql';

@Component({
    selector: 'product-validation',
    templateUrl: './product-validation.component.html',
    styleUrls: ['./product-validation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [SharedModule],
})
export class ProductValidationComponent
    extends TypedBaseDetailComponent<
        typeof ProductValidationDocument,
        'normalizeProductStatus'
    >
    implements OnInit
{
    isProductOkay = true;
    errors: { type: string; message: string }[] = [];
    details: {
        isActive: boolean;
        hasPrice: boolean;
        hasStock: boolean;
        hasMeasurementUnit: boolean;
    } = {
        isActive: false,
        hasPrice: false,
        hasStock: false,
        hasMeasurementUnit: false,
    };

    constructor(
        protected dataService: DataService,
        private cdr: ChangeDetectorRef
    ) {
        super();
    }

    detailForm: UntypedFormGroup;

    // sem form, só exibe dados
    protected setFormValues(): void {}

    ngOnInit() {
        const productId = this.route.snapshot.params['id'];

        this.dataService
            .query(ProductValidationDocument, { productId })
            .single$.subscribe(({ normalizeProductStatus }) => {
                if (normalizeProductStatus) {
                    this.isProductOkay = normalizeProductStatus.isProductOkay;
                    this.details = {
                        isActive: normalizeProductStatus.details.isActive,
                        hasPrice: normalizeProductStatus.details.hasPrice,
                        hasStock: normalizeProductStatus.details.hasStock,
                        hasMeasurementUnit:
                            normalizeProductStatus.details.hasMeasurementUnit,
                    };

                    // garante array novo + remove nulls
                    this.errors = (normalizeProductStatus.errors ?? [])
                        .filter(
                            (e): e is { type: string; message: string } => !!e
                        )
                        .map((e) => ({ type: e.type, message: e.message }));
                    this.cdr.markForCheck(); // força refresh no OnPush
                }
            });
    }

    // Método auxiliar para traduzir os tipos de erro
    getErrorTranslationKey(errorType: string): string {
        const translationMap: { [key: string]: string } = {
            INACTIVE: 'product-validation.errors.inactive',
            NO_PRICE: 'product-validation.errors.noPrice',
            NO_STOCK: 'product-validation.errors.noStock',
            NO_MEASUREMENT: 'product-validation.errors.noMeasurement',
            NOT_FOUND: 'product-validation.errors.notFound',
            PROCESSING_ERROR: 'product-validation.errors.processingError',
        };

        return translationMap[errorType] || 'product-validation.errors.generic';
    }

    // Filtra apenas os erros que não são relacionados aos details básicos
    getNonDetailErrors(): { type: string; message: string }[] {
        const detailErrorTypes = [
            'INACTIVE',
            'NO_PRICE',
            'NO_STOCK',
            'NO_MEASUREMENT',
        ];
        return this.errors.filter(
            (err) => !detailErrorTypes.includes(err.type)
        );
    }

    // Verifica se há algum erro não relacionado aos details
    hasNonDetailErrors(): boolean {
        return this.getNonDetailErrors().length > 0;
    }
}
